import React from "react";
import { Box, Container, Typography } from "@mui/material";
import "./utilitarian.scss";

const UtilitarianSection = () => {
  return (
<>
    <div className="utilm">
        <Container>
            <Box className="util-wrapper">
      
      {/* Top Content */}
      <Box className="util-content">
        
        {/* Left Image Placeholder */}
        <Box className="util-image">
         <img src="/images/rn.png" alt="" />
        </Box>

        {/* Right Text */}
        <Box className="util-text">
          <Typography className="util-para">
            At Utilitarian Labs, we help BFSI organizations implement and
            optimize Salesforce solutions tailored to their business needs—
          </Typography>

          <Typography className="util-highlight">
            Driving measurable outcomes and long-term success.
          </Typography>
        </Box>
      </Box>

   

    </Box>
    </Container>
   

    </div>
     <div className="del">
        <div className="indelhr"></div>
         <div className="logohr">
            <div className="logdiv"> <img src="/images/p.svg" alt="" /></div>
            <div className="contdiv">
                <p>Kiran Kumar Naik </p>
                <span>Head Delivery</span>
            </div>
         </div>

    </div>
</>
  );
};

export default UtilitarianSection;